<template>
  <div class="p-0 p-md-3 p-lg-3 pt-md-4 pt-5">
    <p
      v-if="challenge"
      class="ml-2 text-black font-weight-bold mb-0"
    >
      ID: {{ challenge.id }} / {{ authUser.grade_name }} / {{ selectedCycle.cycle_name }} / Desafio
    </p> 
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          md="4"
          class="pl-md-0"
        >
          <MarkerComponent
            v-model="activeTab"
            :active-tab="activeTab"
            :challenge="challenge"
          />
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="mt-4 mt-md-0"
        >
          <v-card
            rounded="sm"
            elevation="4"
          >
            <div
              v-for="(question, key) in questions"
              v-show="activeTab === key"
              :key="key"
            >
              <div class="font-weight-bold p-3 text-black">
                Questão {{ question.key + 1 }} - {{ question.module_name }}
              </div>
              <div
                :style="`min-height: 700px; overflow-y: auto; overflow-x:hidden`"
                class="p-3 bg-white"
              >
                <QuestionContent :question="currentQuestion" />
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="4"
          class="pr-md-0"
        >
          <v-card
            rounded="sm"
            elevation="4"
          >
            <div class="d-flex justify-content-between p-3 flex-wrap">
              <v-btn
                color="nitro"
                class="white--text my-1 px-6"
                small
                outlined
                :disabled="activeTab === 0"
                :style="{ 
                  borderColor: activeTab === 0 ? '#8280bf!important' : '',
                  color: activeTab === 0 ? '#8280bf!important' : '',
                }"
                @click="decrease"
              >
                <i class="fas fa-chevron-left align-middle mr-2" />
                <span
                  class="align-middle first-letter-capitalize"
                > Questão Anterior</span>
              </v-btn>
              <v-btn
                color="nitro"
                class="white--text my-1 px-6"
                small
                :disabled="activeTab === questions.length - 1"
                :style="{ 
                  backgroundColor: activeTab === questions.length - 1 ? '#8280bf!important' : '',
                  color: activeTab === questions.length - 1 ? 'white!important' : '',
                }"
                @click="increase"
              >
                <span
                  class="align-middle first-letter-capitalize"
                > Próxima Questão </span>
                <i class="ml-2 fas fa-chevron-right align-middle" />
              </v-btn>
            </div>
            <QuestionChoiceSelector
              :question="currentQuestion"
              @click="answerQuestion"
            />
          </v-card>
          <v-card
            rounded="sm"
            class="mt-4"
            elevation="4"
          >
            <v-card-text
              v-if="challenge.started_at && !challenge.finished_at"
              class="d-flex justify-content-between"
            >
              <div style="width: 130px">
                <TimeCounter />
              </div>
              <v-btn
                small
                color="nitro"
                class="white--text w-50"
                @click="onFinish"
              >
                <span class="first-letter-capitalize">
                  Finalizar desafio
                </span>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MarkerComponent from './components/MarkerComponent'
import QuestionContent from './components/QuestionContent'
import QuestionChoiceSelector from './components/QuestionChoiceSelector'
import { mapActions, mapGetters } from 'vuex'
import TimeCounter from "./components/TimeCounter.vue"
import { studyNowRouteName } from '@/student/constants/routes';


export default {
  components: {
    MarkerComponent,
    QuestionContent,
    TimeCounter,
    QuestionChoiceSelector,
  },
  data() {
    return {
      activeTab: 0,
      request_time: 0,
      slow_time: 15,
    }
  },
  computed: {
    ...mapGetters(['selectedCycle','challenge','authUser']),
    questions() {
      return this.challenge.questions
    },
    canStart() {
      return  !this.challenge.finished_at && this.$moment(this.challenge.unavailable_at).isAfter(this.$moment())
    },
    currentQuestion() {
      return this.questions[this.activeTab]
    },
  },
  created() {
    this.getChallenge({id: this.$route.params.challenge_id})
    .then(({ data : { data: challenge }}) => {
      if(challenge.finished_at){
        this.$router.push({ name: studyNowRouteName })
      }
    })
  },
  methods: {
    ...mapActions(['answerChallenge','load']),
    ...mapActions([
      'finishChallenge',
      'getCycles'
    ]),
    ...mapActions(['getChallenge']),
    increase() {
      this.activeTab += this.activeTab < this.questions.length - 1 ? 1 : 0
    },
    decrease() {
      this.activeTab -= this.activeTab > 0 ? 1 : 0
    },
    onFinish(){
      this.$swal({
  title: "Finalizar desafio?",
  html: `<div style="white-space: pre-wrap; text-align: center;">Após marcar o botão de conclusão desta prova, você não poderá voltar para alterar respostas ou conferir alguma marcação. Certifique-se que respondeu TODAS as questões antes de dar o próximo passo.

Lembre-se: o resultado completo poderá ser visto imediatamente após a conclusão da prova ou após o fim do ciclo, de acordo com a definição da sua escola.</div>`,
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "#de0014",
  cancelButtonColor: "#6b757e",
  cancelButtonText: "Cancelar",
  confirmButtonText: "Sim, finalizar!",
  width: '50%',
  allowOutsideClick: false
}).then((result) => {
  if (result.isConfirmed) {
     const data = {id: this.challenge.id };
      this.finishChallenge(data)
      .then(() => {
        this.getCycles().then(() => {
          this.$swal({
            title: "Finalizado!",
            text: "Sua prova foi finalizada com sucesso.",
            icon: "success",
            confirmButtonColor: "#de0014",
            confirmButtonText: "Voltar para o Estude agora",
            width: '50%',
            allowOutsideClick: false
          })
          .then(() => {
            this.$router.push({ name: studyNowRouteName })
          });
        });
      });
  }
});
    },
    answerQuestion(alternative){
      if(this.challenge.finished_at)
        return;
      
      this.load({ isLoading: true, message: 'Respondendo...'})
      let nIntervId
        
        nIntervId = setInterval(() => {
          this.request_time+=1
          if(this.request_time >= this.slow_time){
            this.load({
              isLoading: true, 
              message: 'O processo está demorando mais do que o normal. Por favor, aguarde.'
            })
          }
        }, 1000)

      this.answerChallenge({
          id: this.challenge.id,
          data: {
            user_answer: alternative,
            question_id: this.currentQuestion.id
          }
      })
      .finally(()=> {
        this.load(false)
        clearInterval(nIntervId)
        this.request_time = 0
      })
    }
  }
}
</script>
